module.exports = __webpack_public_path__ + "img/14dbb37dce3f26f352a23589a7192525.svg";